import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [clientUser, setClientUser] = useState(() => {
        const saved = localStorage.getItem('clientUser');
        return saved ? JSON.parse(saved) : null;
    });

    const [adminUser, setAdminUser] = useState(() => {
        const saved = localStorage.getItem('adminUser');
        return saved ? JSON.parse(saved) : null;
    });

    // Persist to localStorage
    useEffect(() => {
        if (clientUser) {
            localStorage.setItem('clientUser', JSON.stringify(clientUser));
        } else {
            localStorage.removeItem('clientUser');
        }
    }, [clientUser]);

    useEffect(() => {
        if (adminUser) {
            localStorage.setItem('adminUser', JSON.stringify(adminUser));
        } else {
            localStorage.removeItem('adminUser');
        }
    }, [adminUser]);

    const loginClient = (user) => {
        setClientUser(user);
    };

    const loginAdmin = (admin) => {
        setAdminUser(admin);
    };

    const logoutClient = () => {
        setClientUser(null);
        localStorage.removeItem('clientUser');
    };

    const logoutAdmin = () => {
        setAdminUser(null);
        localStorage.removeItem('adminUser');
    };

    const value = {
        clientUser,
        adminUser,
        isClientAuthenticated: !!clientUser,
        isAdminAuthenticated: !!adminUser,
        loginClient,
        loginAdmin,
        logoutClient,
        logoutAdmin
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
